import logRocket from 'logrocket'
import { useQuery, UseQueryResult } from '@tanstack/react-query'

import { HEADERS, CATCH_ALL_ERROR_MESSAGE } from '../constants'
import { Task } from '../CustomizeDashboard/Widgets/BadgeWidget/types'
import { useHostServices } from '../HostServices'

export type TokenType = string | null

export const getSecurityTasks = async (token: TokenType): Promise<Task[]> => {
  if (token) {
    try {
      const resp = await fetch('/acs/badges/security', {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
          ...HEADERS,
        },
      })

      if (resp.ok) {
        const { data } = await resp.json()
        return data
      }
      throw new Error(CATCH_ALL_ERROR_MESSAGE)
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message)
      }
    }
  }
  logRocket.captureMessage(
    `ally-next-remote-dashboard: useSecurityTasks - Session token is missing`,
  )
  throw new Error(CATCH_ALL_ERROR_MESSAGE)
}

export function useSecurityTasks(): UseQueryResult<Task[]> {
  const { session } = useHostServices()

  const token = session.data && session.data.access_token

  // staleTime set to Infinity to fetch and cache the API response only once
  const securityTasks = useQuery(
    ['security-tasks'],
    () => getSecurityTasks(token),
    {
      enabled: !!token,
      staleTime: Infinity,
    },
  )

  return securityTasks
}
